import React from 'react';
import GallerySection from '../components/GallerySection';
import VideoGallerySection from '../components/VideoGallerySection';
import './Gallery.css';

const Gallery: React.FC = () => {
  return (
    <div className="gallery-page">
      {/* Photo Gallery Section */}
      <section className="section-padding">
        <div className="page-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            background: 'linear-gradient(135deg, #6366f1, #10b981)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            fontSize: '2.75rem',
            marginBottom: '1rem'
          }}>
            Our Gallery
          </h1>
          <p style={{ color: '#1f2937', fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto' }}>
            Explore highlights from our tech programs and see the amazing projects our students have created.
          </p>
        </div>
        <GallerySection />
      </section>

      {/* Video Gallery Section */}
      <section className="section-padding bg-gray-50">
        <VideoGallerySection />
      </section>
    </div>
  );
};

export default Gallery;
